<!-- Top Navbar -->
    <Navbar>
      <NavLeft>
        {#if isSidebar}
        <a href="#" on:click={fCollapseSidebar}
            style="padding: 0 0 0 10px;">
           <i style="font-size: 18px;" class="icon f7-icons">
            {#if isMobile}
              {isCollapse ? "chevron_up" :  "chevron_down"}
            {:else}
              {isCollapse ? "chevron_right_2" :  "chevron_left_2"}
            {/if}
            </i>
        </a>
        {:else}
        <div style="width:20px"></div>
        {/if}
      </NavLeft>
      <NavTitle>
        <Link class="header-link nav-link" href="/" style="padding:0;">
          <img src="./static/img/logo.png" alt="Prevention TaskForce Search" style="height: 40px;" class="logo-img"/>
        </Link>
      </NavTitle>
      <NavRight class="header-menu">
        <Link class="header-link nav-link" 
        href="https://www.uspreventiveservicestaskforce.org/apps/" external target="_blank">
        Apps
         </Link>
         <Link class="header-link nav-link" href="/bygrade">By Grade</Link>
         <Link class="header-link nav-link" href="/bytopic">By Topic</Link>
         <Link class="header-link nav-link" href="/tools">Tools</Link>
      </NavRight>
      <div style="margin-left: auto" class="menu-item menu-item-dropdown">
        <div class="menu-item-content icon-only">
          <div class="menu-item-content">
            <i class="f7-icons">bars</i>
          </div>
        </div>
        <div class="menu-dropdown menu-dropdown-right">
          <div class="menu-dropdown-content">
            <Link class="menu-dropdown-link menu-close" 
                  href="https://www.uspreventiveservicestaskforce.org/apps/" external target="_blank">
              Apps
            </Link>
            <Link class="menu-dropdown-link menu-close" href="/">By Grade</Link>
            <Link class="menu-dropdown-link menu-close" href="/bytopic">By Topic</Link>
            <Link class="menu-dropdown-link menu-close" href="/tools">Tools</Link>
            <Button style="margin:10px;" fill small onClick={() => refreshapi()}>Update Recommendations</Button>
          </div>
        </div>
    </Navbar>

<script>
  import {
    Navbar,
    NavLeft,
    NavRight,
    NavTitle,
    Link,
    Button
  } from 'framework7-svelte';
  import { createEventDispatcher, onDestroy } from 'svelte';
  import { searchData, lastUpdated, apiurl } from '../stores.js';
  import { groupBy } from '../utils.js';

  const dispatch = createEventDispatcher();

  let data;
  let apiUrl;
  let sLastUpdated, sLastUpdatedText;
  let isMobile = true;

  $: fResize();

  function fResize() {
    if (window.innerWidth > 850) {
      isMobile = false;
    } else {
      isMobile = true;
    }
  }

  window.addEventListener("resize", fResize);

  const fCollapseSidebar = () => dispatch('click');

  const unsubscribeLastUpdated = lastUpdated.subscribe(value => {
    if (!value) { return; }
    sLastUpdated = value.lastUpdated;
    sLastUpdatedText = value.lastUpdatedText;
	});
  onDestroy(unsubscribeLastUpdated);

  function refreshapi() {
   getSearchData()
  }

  export let isSidebar;
  export let isCollapse;

  const unsubscribeAPIURL = apiurl.subscribe(value => {
    if (!value) {
      fetch("config.json") 
      .then(response => response.json()) 
      .then(parsed => {
          apiUrl = parsed.API_URL;
        })
        .catch(error => {
          console.log('Error! ', error);
        });
    } else {
      apiUrl = value; 
    }
	});
  onDestroy(unsubscribeAPIURL);

  

  // Get Data
  async function getSearchData() {
    if (!apiUrl) { 
      fetch("config.json") 
      .then(response => response.json()) 
      .then(parsed => {
        apiUrl = parsed.API_URL;
        if (apiUrl) {
          apiurl.set(apiUrl);
        }
      })
      .catch(error => {
        console.log('Error! ', error);
      });
      return; 
    }

      //get cached etags
    var cachedetags = JSON.parse(localStorage.getItem('etgas'));     
    var isReloadAPIData = false;

    await fetch(apiUrl, {cache: 'no-store'})
    .then(response => {
      // extract etags from headers
      var etagsdata = response.headers.get('etag');
      if (!etagsdata) {
        isReloadAPIData = true;
      }
      // compare cached etags with the API etags
      if (etagsdata) {
        localStorage.setItem('etgas', JSON.stringify(etagsdata));
        if(etagsdata != cachedetags) {
          isReloadAPIData = true;
        } else {
          isReloadAPIData = false;
        }
      }
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json();
    }) 
    .then(parsed => {
      data = parsed;
      if (!data) {
        throw Error('Empty JSON data');
      }
     
      if (!data.generalRecommendations || !data.specificRecommendations) {
        throw Error('Missing recommendation data');
      }

      if (isReloadAPIData) {
        // if API is newer version
          const genRecArr = data && data.generalRecommendations;
          data && data.specificRecommendations && data.specificRecommendations.forEach(recommendation => {
            recommendation.generalRecommendation = genRecArr[recommendation.general];
            // recommendation.title = addTextStyle(recommendation.title);
            recommendation.tools = [];
            recommendation.tool && recommendation.tool.forEach(id => {
              if (data.tools && data.tools[id]) recommendation.tools.push(data.tools[id]);
            });
          });
          data.recGroupedByGrade = groupBy( data.specificRecommendations, 'grade');
          searchData.set(data);
          lastUpdated.set({'lastUpdated':data.lastUpdated, 'lastUpdatedText':data.lastUpdatedText});
        }
      
      return data;
    }
    ) 
    .catch(error => {
      console.log('Looks like there was a problem: \n', error);
    });
  }
</script>
<style>
.nav-link {
  font-size: 0.9rem !important;
}
.nav-link:hover,
.nav-link:active {
  text-decoration: none !important;
}
</style>